import axios from 'axios';
import { urlroot } from '../../globals/GlobalContext';


export var ZT:any = {};
export var NIST:any = {};

async function GetZTFile(filename:any){
    return axios(`${urlroot}zt/${filename}.json`).then(response => {
        ZT = {...ZT, 
        ...response.data};
    });
}

async function GetNISTFile(filename:any){
    return axios(`${urlroot}n800/${filename}.json`).then(response => {
        NIST = {...NIST, 
        ...response.data};
    });
}

export async function GetZeroTrustFilesAll(){

    if(Object.keys(ZT).length > 0) return;

    let promiseMe:any = [];
    promiseMe.push(GetZTFile('zt-desc'));
    promiseMe.push(GetZTFile('zt-800mapping'));
    promiseMe.push(GetZTFile('zt-attack-prevalence'));
    promiseMe.push(GetNISTFile('n800-desc'));
 
    return await Promise.all(promiseMe);
  }

export default function ZeroTrustData(props:any){
    return(
        <></>
    )
}